import { render, staticRenderFns } from "./otherInStockDetail.vue?vue&type=template&id=75531343&scoped=true&"
import script from "./otherInStockDetail.vue?vue&type=script&lang=js&"
export * from "./otherInStockDetail.vue?vue&type=script&lang=js&"
import style0 from "./otherInStockDetail.vue?vue&type=style&index=0&id=75531343&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75531343",
  null
  
)

export default component.exports